import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, Output, ChangeDetectionStrategy } from '@angular/core';

import { Room } from '@shared/factories';

export const BULK_TAB = 'bulk';
export type  ChatTab  = number | typeof BULK_TAB;

const CHIP_WIDTH = 36;
const OPEN_WIDTH = 240;

@Component({
  selector:      'chat-tabs',
  templateUrl: './chat-tabs.component.html',
  host: { class: 'relative am-flex-align-stretch am-flex-shrink-0 height-40 bb-grey select-none' },
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ChatTabsComponent implements OnChanges, AfterViewInit {
  @Input() rooms:    Room[] = [];
  @Input() bulkMode: boolean;
  @Input() selected: ChatTab;

  @Output() selectTab = new EventEmitter<ChatTab>();
  @Output() closeBulk = new EventEmitter<void>();

  readonly BULK_TAB = BULK_TAB;
  indicator = { left: 0, width: 0 };
  private layoutKey: string;
  constructor( private eRef: ElementRef ) { }

  ngOnChanges(): void {
    this.scheduleIndicator();
  }

  ngAfterViewInit(): void {
    this.scheduleIndicator(true);
  }

  @HostListener('transitionend', ['$event'])
  transitionEnd(event: TransitionEvent): void {
    if (event.propertyName === 'max-width' && (event.target as HTMLElement)?.tagName === 'CHAT-BOX-HEADER') this.updateIndicator();
  }

  pick(room: Room): void {
    if (room.id !== this.selected) this.selectTab.emit(room.id);
  }

  private scheduleIndicator(force: boolean = false): void {
    let key = `${this.rooms?.map(r => r.id).join(',')}|${this.selected}|${this.bulkMode}`;
    if (!force && key === this.layoutKey) return;
    this.layoutKey = key;
    setTimeout(() => this.updateIndicator());
  }

  private updateIndicator(): void {
    let left = 0, width = 0;
    for (let el of Array.from(this.eRef.nativeElement.children) as HTMLElement[]) {
      if (el.hasAttribute('data-indicator')) continue;
      let active = el.hasAttribute('data-active');
      let isRoom = el.tagName === 'CHAT-BOX-HEADER';
      let w      = isRoom ? (active ? this.openWidth(el) : CHIP_WIDTH) : el.offsetWidth;
      if (active) { width = w; break; }
      left += w;
    }
    this.indicator = { left, width };
  }

  private openWidth(el: HTMLElement): number {
    let expanding = parseFloat(getComputedStyle(el).maxWidth) < OPEN_WIDTH;
    return expanding ? OPEN_WIDTH : Math.min(el.scrollWidth, OPEN_WIDTH);
  }

}
